<template>
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol xl="6">
          <CSelect description="Zupanija" :value.sync="selectedRegion" :options="['Split i okolica', 'Zagreb', 'Sve']" />
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="6">
          <CDataTable :hover="true" :striped="true" :items="hoodData" :fields="fields" sorter class="hover"> </CDataTable>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
const columns = [
  { key: "city", label: "grad" },
  { key: "hood", label: "kvart" },
  { key: "type", label: "tip" },
  { key: "pricePerSqm", label: "€/m2" },
  { key: "count", label: "broj" },
];

import moment from "moment";
export default {
  name: "Table",
  props: {
    fields: {
      type: Array,
      default() {
        return columns;
      },
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },

  data() {
    return {
      estateAds: [],
      hoods: [],
      gradoviSplitIOkolica: ["Kaštela", "Solin", "Solin - Okolica", "Split", "Split - Okolica"],
      selectedRegion: "Split i okolica",
    };
  },
  computed: {
    hoodData() {
      let hoods = this.$store.state.hoods.filter((hood) => {
        let isWithinSelectedRegion = true;
        if (this.selectedRegion === "Split i okolica") {
          isWithinSelectedRegion = this.gradoviSplitIOkolica.some((c) => c === hood.city);
        } else if (this.selectedRegion === "Zagreb") {
          isWithinSelectedRegion = !this.gradoviSplitIOkolica.some((c) => c === hood.city);
        }
        return isWithinSelectedRegion;
      });
      hoods.sort((a, b) => a.pricePerSqm - b.pricePerSqm);
      return hoods;
    },
  },
};
</script>
<style scoped>
table a {
  color: inherit;
}
table a:hover {
  text-decoration: none;
}
</style>
